import React, { Fragment, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import Cookies from "js-cookie";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "../../css/custom.css";
import TopNav from "../../components/TopNav/TopNav";
import WaveformAnalysisTab from "../../components/tabs/WaveformAnalysis/WaveformAnalysis";
import TrendingAnalysisTab from "../../components/tabs/TrendingAnalysis/TrendingAnalysis";
import EventsAnalysisTab from "../../components/tabs/EventsAnalysis/EventsAnalysis";
import HarmonicAnalysisTab from "../../components/tabs/HarmonicAnalysisTab";
import DailyReportsTab from "../../components/tabs/DailyReports";
import Alerts from "../../components/tabs/Alerts";
import DeploymentsTab from "../../components/tabs/Deployments/DeploymentsTab";
import CommonAPI from "../../api/CommonApi";
import { useDispatch, useSelector } from "react-redux";
import { equipmentsPortfolioActions } from "../../store/equipmentsPortfolioSlice/equipmentsPortfolioSlice";
import { tabStatusActions } from "../../store/tabStatusSlice/tabStatusSlice";
import Button from "react-bootstrap/Button";
import ScrollButton from "../../components/TopNav/components/ScrollButton/ScrollToTopButton";
import ChangeLog from "../../components/ChangeLog/ChangeLog";
import ChatBot from "../../components/ChatBot/ChatBot";

const { setIntervalAsync } = require("set-interval-async/fixed");

export default function Dashboard() {
    const token = Cookies.get("Session");
    const dispatch = useDispatch();

    const [displayChangeLog, setDisplayChangeLog] = useState(false);
    const onVersionChangeClick = () => {
        setDisplayChangeLog(true);
    };

    const [activeTabKey, setActiveTabKey] = useState("Waveform Analysis");

    const plotEvent = useSelector((state) => state.plotEvent);
    useEffect(() => {
        if (plotEvent.time) {
            setActiveTabKey("Events");
        }
    }, [plotEvent]);

    const check_jwt_expiry = () => {
        const token = Cookies.get("Session");
        let tokenDuration = new Date().getTime();
        if (token !== undefined) {
            tokenDuration = new Date(jwt_decode(token).exp * 1000).getTime();
        }

        if (new Date().getTime() >= tokenDuration) {
            Cookies.remove("Session");
            window.location = process.env.REACT_APP_PORTAL_URL + "#/logout";
        }
    };

    useEffect(() => {
        setIntervalAsync(check_jwt_expiry, 10000);
        CommonAPI.getCustomerPortfolio(token).then((response) =>
            dispatch(equipmentsPortfolioActions.setEquipmentPortfolio(response.data.content)),
        );
    }, []);

    return (
        <div className="body">
            <React.Fragment>
                <Container fluid hidden={displayChangeLog}>
                    <Row>
                        <Col>
                            <TopNav />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Tabs
                                defaultActiveKey="Waveform Analysis"
                                id="menu-tabs"
                                variant="pills"
                                onSelect={(tabName) => {
                                    dispatch(tabStatusActions.setSelectedTab(tabName));
                                    setActiveTabKey(tabName);
                                }}
                                activeKey={activeTabKey}
                            >
                                <Tab eventKey="Waveform Analysis" title="Waveform Analysis">
                                    <WaveformAnalysisTab />
                                </Tab>
                                <Tab eventKey="Harmonic Analysis" title="Harmonic Analysis">
                                    <HarmonicAnalysisTab />
                                </Tab>
                                <Tab eventKey="Trending Analysis" title="Trending Analysis">
                                    <TrendingAnalysisTab />
                                </Tab>
                                <Tab eventKey="Events" title="Events Analysis">
                                    <EventsAnalysisTab />
                                </Tab>
                                <Tab eventKey="Reports" title="Daily Reports">
                                    <DailyReportsTab />
                                </Tab>
                                <Tab eventKey="Alerts" title="Alerts">
                                    <Alerts />
                                </Tab>
                                <Tab eventKey="Deployments" title="Deployments">
                                    <DeploymentsTab />
                                </Tab>
                            </Tabs>
                        </Col>
                        <ScrollButton />
                    </Row>
                    <ChatBot />
                    <Row className="align-content-center">
                        <Col className="mt-5 offset-5">
                            <h6>
                                Version 1.22.12{" "}
                                <a className="changelog-link" onClick={onVersionChangeClick}>
                                    See What's Changed
                                </a>
                            </h6>{" "}
                        </Col>
                    </Row>
                </Container>
                <Container fluid id="changelog" hidden={!displayChangeLog}>
                    <ChangeLog setDisplayChangeLog={setDisplayChangeLog} hidden={!displayChangeLog} />
                </Container>
            </React.Fragment>
        </div>
    );
}
